module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class=\'mbx-info\'>\n    <p>' +
((__t = ( i18next.t('ui.disable_confirmation', {name}) )) == null ? '' : __t) +
'</p>\n    ';
 if (warning) { ;
__p += '\n        <div class="modal-description-container">\n            <span class="modal-description-title">\n                <i class="' +
((__t = ( WiseMetering.icons.info )) == null ? '' : __t) +
'" style="margin-right: 10px; color: #2a81c0; font-size: 2em;" aria-hidden=\'true\'></i>\n            </span>\n            <p style="margin: 0">' +
((__t = ( warning )) == null ? '' : __t) +
'</p>\n        </div>\n    ';
 } ;
__p += '\n    <form>\n        <dl class=\'stepped zero\'>\n            <dt>\n                <label for=\'integration_configuration_comment\'>' +
((__t = ( i18next.t('integration_configurations.disable_reason') )) == null ? '' : __t) +
'</label>\n            </dt>\n            <dd>\n                <textarea class=\'text\' id=\'integration_configuration_comment\' name=\'integration_configuration[comment]\'></textarea>\n            </dd>\n        </dl>\n    </form>\n</div>\n';

}
return __p
}